import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import notificationService from "../../../../api/Notification/NotificationService";
export default class CreateNotification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notification: { id: null, title: null, dept: null, description: null },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (e) => {
    let notification = this.state.notification;
    notification[e.target.name] = e.target.value;
    this.setState({ notification });
  };

  onButtonClick = () => {
    notificationService.addNotification({
      title: this.state.notification.title,
      dept: this.state.notification.dept,
      description: this.state.notification.description,
    });
    toast.success(`Notification Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      notification: { id: null, title: null, dept: null, description: null },
    });
    document.getElementById("title").value = "";
    document.getElementById("dept").value = "";
    document.getElementById("description").value = "";
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Notification</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Title</label>
              <FormControl
                autoFocus
                type="text"
                name="title"
                id="title"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Department</label>
              <FormControl
                autoFocus
                type="text"
                name="dept"
                id="dept"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4 align-self-end">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <FormControl
                autoFocus
                type="textarea"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group pt-2 align-self-end" align="right">
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Send
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
